import React, { useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { ToastMessage, Button } from '@cokitchen/cokitchen-components';
import { ENUM_REQUEST_STATUS } from 'models/common.model';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import useRoleContext from 'contexts/role.context';
import { InventoryModule, RolePermission } from 'models/permission.model';
const PrepItemMenu = ({
  status,
  ids,
  onSuccess
}: {
  status: ENUM_REQUEST_STATUS;
  ids: string;
  onSuccess?: () => void;
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isPrepTeamRoute = pathname.includes('prep-team');
  const { can } = useRoleContext();
  const canWriteKitchenRequisition = can(InventoryModule.KitchenRequisition, RolePermission.Write);

  const [loading, setLoading] = useState(false);
  const receiveItem = async (ids: string) => {
    if (!canWriteKitchenRequisition) return;
    setLoading(true);
    try {
      await apiService.put(`prep-kitchen-request/${id}/received`, {
        version: 'v2',
        data: {
          prep_request_item_ids: [ids]
        }
      });

      toast(<ToastMessage type='success' message='Item received' />);
      onSuccess?.();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  const cancelItem = async (ids: string) => {
    if (!canWriteKitchenRequisition) return;
    setLoading(true);
    try {
      await apiService.put(`prep-kitchen-request/${id}/cancel`, {
        version: 'v2',

        data: {
          prep_request_item_ids: [ids]
        }
      });
      toast(<ToastMessage type='success' message='Item cancelled' />);
      onSuccess?.();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  const logReport = () => {
    if (!canWriteKitchenRequisition) return;
    if (isPrepTeamRoute) {
      navigate(`/prep-team/prep-team-requests/report/${id}`);
    } else {
      navigate(`/main-store/brand-chefs/manage-requests/production-report/${id}`);
    }
  };
  const menuOptions: Partial<
    Record<ENUM_REQUEST_STATUS, { label: string; onClick: (arg0: string) => void }[]>
  > = {
    [ENUM_REQUEST_STATUS.SENT]: [
      {
        label: 'Item received',
        onClick: receiveItem
      },

      {
        label: 'Item not received',
        onClick: cancelItem
      }
    ],
    [ENUM_REQUEST_STATUS.RECEIVED]: [
      {
        label: 'Log Report ',
        onClick: logReport
      }
    ],
    [ENUM_REQUEST_STATUS.COMPLETED]: [
      {
        label: 'Cancel Item',
        onClick: cancelItem
      }
    ]
  };
  if (!canWriteKitchenRequisition) {
    return null;
  }
  return (
    <div className='flex gap-2'>
      {menuOptions[status]?.map((item, index) => (
        <Button
          key={index}
          disabled={loading}
          variant='outline'
          color='primary'
          small
          className='max-w-40 text-sm py-2 px-3'
          onClick={() => item.onClick(ids)}>
          {item.label}
        </Button>
      ))}
    </div>
  );
};

export default PrepItemMenu;
